module.exports = __webpack_public_path__ + "static/media/3a.778c6319.gif";